import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetasCupones: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).add(30, 'days').format('YYYY-MM-DD'),
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.tarjetasCupones = [];
    },
    'SET_TARJETAS_CUPONES'(state, tarjetasCupones) {
        state.tarjetasCupones = tarjetasCupones;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const actions = {
    getTarjetasCupones: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            /*    
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.bancoCuenta) {
                if (state.bancoCuenta.id != 0) {
                    queryString += '&bancoCuentaId=' + state.bancoCuenta.id;
                }
            }
            */

            apiAxios.get('tarjetascupones' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_TARJETAS_CUPONES', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}